import * as _ from "underscore";
import * as React from "react";
import * as moment from "moment";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { Panel, Table } from "react-bootstrap";

import Money from "../../../Money";
import { additionalIncomeCalculationMethods } from "../../shared";
import LabeledInput from "../../../LabeledInput";
import { PaySectionProps } from "./shared";

const humanize = require("underscore.string/humanize");
const uuid = require("uuid");

export default class AdditionalIncomeSection extends React.Component<PaySectionProps, any> {
  handleOnChange(field, ev) {
    let value;
    if (ev) {
      if (ev.hasOwnProperty("value")) {
        value = ev.value;
      } else if (ev.hasOwnProperty("target")) {
        value = ev.target.type === "checkbox" ? ev.target.checked : ev.target.value;
      }
    }
    this.props.updateAggregation(field, value);
  }

  render() {
    const summary = this.props.data && this.props.data.context;
    const income_map = this.props.data && this.props.data.monthlyIncomeMap;
    const sparklineData = summary.summary.map(item => Number(item.monthly_average));
    sparklineData.reverse();

    const options = _.map(additionalIncomeCalculationMethods, t => ({
      value: t,
      label: `${humanize(t)} ($${income_map[t]})`,
    }));

    return (
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>{this.props.data.context.name}</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <LabeledInput
              inputType="boolean"
              labelValue="Include In Ratios"
              inputName={`include_in_ratios${uuid.v4()}`}
              inputValue={this.props.data.include_in_ratios}
              onChange={this.handleOnChange.bind(this, "include_in_ratios")}
            />
            <dl className="dl-horizontal salaried_income__summary">
              <dt>Years in this Employment</dt>
              <dd>
                {summary && summary.employment_info && summary.employment_info.years_in_employment}
              </dd>
              <dt>Pay Period End Date</dt>
              <dd>
                {summary &&
                  summary.employment_info &&
                  summary.employment_info.pay_period_end_date &&
                  moment.utc(summary.employment_info.pay_period_end_date).format("MM/DD/YYYY")}
              </dd>
            </dl>
            <Table>
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Source</th>
                  <th>Amount </th>
                  <th># of Months </th>
                  <th>Monthly Average </th>
                </tr>
              </thead>
              <tbody>
                {summary &&
                  summary.summary &&
                  summary.summary.length > 0 &&
                  summary.summary.map((item, i) => (
                    <tr key={i}>
                      <td>{item.label} </td>
                      <td>{item.source} </td>
                      <td>
                        <Money value={item.amount} />
                      </td>
                      <td>{Number(item.number_of_months).toFixed(2)} </td>
                      <td>
                        <Money value={item.monthly_average} />
                      </td>
                    </tr>
                  ))}
                <tr>
                  <td colSpan={3} className="income_summary--right">
                    Income Trend:{" "}
                  </td>
                  <td colSpan={1}>{summary.income_trend}</td>
                  <td colSpan={1}>
                    <Sparklines data={sparklineData} svgHeight={25}>
                      <SparklinesLine />
                    </Sparklines>
                  </td>
                </tr>
                {summary &&
                  summary.summary_calculations &&
                  summary.summary_calculations.length > 0 &&
                  summary.summary_calculations.map((item, i) => (
                    <tr key={i}>
                      <td colSpan={4} className="income_summary--right">
                        {item.label}{" "}
                      </td>
                      <td>
                        <Money value={item.monthly_average} />
                      </td>
                    </tr>
                  ))}
                <tr>
                  <td colSpan={2}>
                    <LabeledInput
                      className="income_summary__calculation_method"
                      inputType="select"
                      condensed
                      labelValue="Calculation Method"
                      inputName="calculation_method"
                      options={options}
                      inputValue={this.props.data.calculation_method}
                      onChange={this.handleOnChange.bind(this, "calculation_method")}
                    />
                  </td>
                  <td colSpan={3} />
                </tr>
                <tr className="income_summary__total_row">
                  <td colSpan={2} />
                  <td colSpan={2} className="income_summary--right">
                    {this.props.data.context.name} Monthly Total:
                  </td>
                  <td colSpan={1}>
                    <Money
                      value={this.props.data.monthlyIncomeMap[this.props.data.calculation_method]}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
            <LabeledInput
              inputType="textarea"
              labelValue="Notes"
              inputName={`notes${uuid.v4()}`}
              inputValue={this.props.data.notes}
              onChange={this.handleOnChange.bind(this, "notes")}
            />
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}
